import React from 'react';
import './Mapa.scss';
import MapBox from '../MapBox/MapBox';

const Mapa = () => {
  return (
    <div id="ubicacion" className='contenedor_mapa'>
      <div className='mapa'>
        <MapBox />
      </div>
    </div>
  );
};

export default Mapa;
